import { render, staticRenderFns } from "./AddProductComposite.vue?vue&type=template&id=40705956"
import script from "./AddProductComposite.vue?vue&type=script&lang=js"
export * from "./AddProductComposite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports